import { atom } from "recoil";
import {
  ICarrierContactPerState,
  ICarrierFiles,
  ICarrierMetricsPerState,
  ICarriers,
  ICarrierStateAppointed,
  IStatesOptions,
} from "../types";

export const defaultCarrierData = {
  masterCarrierId: null,
  carrierName: "",
  states: [],
  fein: "",
  naic: "",
  amBestRating: null,
  dateOfAmBestRating: null,
  carrierStates: [],
  masterCarrierDetails: {
    masterCarrierDetailsId: 0,
    masterCarrierId: null,
    masterCarrierAddress: "",
    notes: "",
    nsa: false,
    splc: false,
    alias: "",
  },
  nsaContacts: [],
  splcContacts: [],
  carrierContactPerState: [],
  carrierFiles: [],
  isActive: true,
  isFranchise: false,
  createdBy: "",
  createdOn: new Date().toLocaleDateString(),
};

export const carrierData = atom<ICarriers>({
  key: "carrierData",
  default: defaultCarrierData,
});
export const filteredCarrierData = atom<Array<ICarriers>>({
  key: "filteredCarrierData",
  default: [],
});

export const isCarrierFiltered = atom<true | false>({
  key: "isCarrierFiltered",
  default: false,
});

export const carrierShowState = atom({
  key: "carriersShowState",
  default: false,
});

export const carrierAddState = atom({
  key: "carriersAddState",
  default: false,
});

export const carrierEditState = atom({
  key: "carriersEditState",
  default: false,
});
export const carrierMassUploadState = atom({
  key: "carriersMassUploadState",
  default: false,
});
export const carrierContactMassUploadState = atom({
  key: "carriersContactMassUploadState",
  default: false,
});
export const carrierContactPerState = atom<Array<ICarrierContactPerState>[]>({
  key: "carrierContactPerState",
  default: [],
});
export const carrierMetricPerState = atom<Array<ICarrierMetricsPerState>[]>({
  key: "carrierMetricPerState",
  default: [],
});
export const carrierStates = atom<Array<IStatesOptions>>({
  key: "carrierStates",
  default: [],
});
export const carrierSourceFiles = atom<Array<ICarrierFiles>>({
  key: "carrierSourceFiles",
  default: [],
});
export const carrierAttachments = atom<File[] | null>({
  key: "carrierAttachments",
  default: null,
});
export const selectedCarriers = atom<Array<IStatesOptions>>({
  key: "selectedCarriers",
  default: [],
});

export const carrierStateAppointed = atom<Array<ICarrierStateAppointed>[]>({
  key: "carrierStateAppointed",
  default: [],
});

export const stateSuspended = atom({
  key: "stateSuspended",
  default: false,
});
